import { queryWorkOrg } from '@api/hr/workOrg';

// 按模块的action, reducer整合体
const WORK_ORG_LIST = 'WORK_ORG_LIST';

export function getWorkOrgList(params) {
  return (dispatch, getState) => {
    const { work_org_list: list } = getState();
    if (list.length > 0) {
      return dispatch({
        type: WORK_ORG_LIST,
        data: list,
      });
    }
    return queryWorkOrg(params).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: WORK_ORG_LIST,
          data: res.data,
        });
      }
    });
  };
}

export function workOrgList(state = [], action) {
  switch (action.type) {
    case WORK_ORG_LIST:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/work_org_list.js